import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { FormAddress, FormHotelName } from "./components";

export const Form = () => {
	return (
		<FeatureIslandMainWithBackGround>
			<div className="space-y-14">
				<FormHotelName />
				<FormAddress />
			</div>
		</FeatureIslandMainWithBackGround>
	);
};
